export const theme = {
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  textAlign: 'center',
  primaryColor: '#FFD700',
  secondaryColor: '#808080',
  tertiaryColor: '#646464',
  quaternaryColor: '#40adec',
  opacityQuaternaryColor: '#cfeafa',
  opacityLightQuaternaryColor: '#f2fafe',
  opacity: 'rgba(0, 0, 0, 0.2)',
  basicColor: 'black',
  backgroundColor: 'white',
  fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
  fontSize: '18px',
  mediaSmaller: '(min-width: 400px)',
  mediaBigger: '(min-width: 800px)',
  mediaSMax: '(max-width: 650px)',
  mediaLMax: '(max-width: 750px)',
  mediaMax: '(max-width: 1350px)',
  darkPrimaryColor: '#d4af37',
  darkQuaternaryColor: '#0571b0',
}
